import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Slots } from '@classes/slots/slots';
import { environment } from '@environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SlotsService {

  keyword = new Subject<string>();

  constructor(
    private http: HttpClient
  ) { }

  /* ----------------------------------- GET ---------------------------------- */
  getParkingPlaceByCamera(cameraId: string): Observable<Slots[]> {
    return this.http.get<Slots[]>(`${environment.apiUrl}/slots?cameraId=${cameraId}`,
      {
        headers: { 'authorization': `Bearer ${environment.tokenKey}` },

      });
  }

  /* -------------------------------------------------------------------------- */

  /* ---------------------------------- POST ---------------------------------- */

  addSlot(id: string) {
    return this.http.post(`${environment.apiUrl}/cameras/${id}/init`, null);
  }
  /* -------------------------------------------------------------------------- */


  /* ----------------------------------- PUT ---------------------------------- */

  /* -------------------------------------------------------------------------- */

}
